import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import  { useState } from "react";


import ArrowForwardIcon from '@mui/icons-material/ArrowForward';





const PurchaseInspectionActionMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess, selectionMode,inspectionApproval }) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);
        handlecallProcess(buttonName);
    };


    return (

        <Grid container display="flex-start" padding={0}>            
            {/* Add Button */}
            {inspectionApproval  && (<>
             <Grid item md={0} ml="5px" mr="5px">

                <Tooltip title="Approve Inspected Orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('ApproveInspection')}>
                            <ArrowForwardIcon style={{ fontSize: "18px", color: selectedButton === 'ApproveInspection' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Approve Inspection</Typography>
                        </IconButton>                        
                    </div>
                </Tooltip>

            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
            </>
            )}
        </Grid>
    )
};
export default PurchaseInspectionActionMenu;